// TODO: add error type
// eslint-disable-next-line
export const shouldRetryOnError = (attempt: number, error: any) => {
  const status = error?.response?.status;
  return attempt < 3 && status >= 500 && status < 600;
};

export const retryDelay = (attempt: number) => {
  const delays = [0, 300, 1000];
  return delays[attempt] !== undefined ? delays[attempt] : 1000;
};
